type HighlightPointerOverlayProps = {
  x: number;
  y: number;
  radius: number;
  visible: boolean;
  className?: string;
};

export default function HighlightPointerOverlay({
  x,
  y,
  radius,
  visible,
  className = "absolute inset-0 pointer-events-none z-20",
}: HighlightPointerOverlayProps) {
  if (!visible) return null;
  const screen =
    typeof window !== "undefined"
      ? Math.min(window.innerWidth, window.innerHeight)
      : 1000;
  const r = (screen * radius) / 100;
  return (
    <div className={className}>
      <svg
        width="100%"
        height="100%"
        className="absolute inset-0 pointer-events-none z-10"
      >
        <defs>
          <mask id="highlightMask">
            <rect width="100%" height="100%" fill="white" />
            <circle cx={`${x}%`} cy={`${y}%`} r={`${r}px`} fill="black" />
          </mask>
        </defs>
        <rect
          width="100%"
          height="100%"
          fill="rgba(0, 0, 0, 0.6)"
          mask="url(#highlightMask)"
        />
        <circle
          cx={`${x}%`}
          cy={`${y}%`}
          r={`${r}px`}
          fill="none"
          stroke="rgba(255, 255, 255, 0.5)"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
}
